import { Range } from '@navfleet/client/shared/models/common';
import { Interval } from '@navfleet/client/weather/earthquake/domain/models';

export function convertIntervalToRange(interval: Interval) {
    const to = new Date();
    const from = new Date(to.toISOString());
    from.setDate(from.getDate() - interval);

    return { from, to } as Range<Date>;
}
